import { User } from './users';
import { objectId } from './catalog';
import { encrypt, matchHash } from './password';
import { createAccessToken, createRefreshToken, Tokens } from './security';

export const login = (email, password) => {
    return new Promise((resolve) => {
        const user = User.all().find((u) => u.email === email);
        if (!user || !matchHash(password, user.password)) {
            return resolve({
                success: false,
                message: 'Invalid email or password.'
            });
        }
        const accessToken = createAccessToken(user);
        const refreshToken = createRefreshToken(user);
        resolve({
            success: true,
            message: 'User logged successfully.',
            data: {
                user: {
                    id: user.id,
                    role: user.role,
                    email: user.email,
                    name: user.name
                },
                accessToken,
                refreshToken
            }
        });
    });
};

export const register = (data) => {
    return new Promise((resolve) => {
        if (User.all().find((u) => u.email === data.email)) {
            return resolve({
                success: false,
                message: 'User email already exists.'
            });
        }
        const user = {
            ...data,
            id: objectId(),
            role: 'user',
            password: encrypt(data.password)
        };
        User.add(user);
        const accessToken = createAccessToken(user);
        const refreshToken = createRefreshToken(user);
        resolve({
            success: true,
            message: 'User registered successfully.',
            data: {
                user: {
                    id: user.id,
                    role: user.role,
                    email: user.email,
                    name: user.name
                },
                accessToken,
                refreshToken
            }
        });
    });
};

export const renew = (currentRefreshToken) => {
    return new Promise((resolve) => {
        const token = Tokens.all().find((t) => t.token == currentRefreshToken);
        if (!token) {
            resolve({
                success: false,
                message: 'Refresh token is not in database.'
            });
        }
        const user = User.find(token.user);
        if (!user) {
            resolve({
                success: false,
                message: 'User not found.'
            });
        }
        const accessToken = createAccessToken(user);
        const refreshToken = createRefreshToken(user);
        resolve({
            success: true,
            message: 'Token renewed successfully.',
            data: {
                user: {
                    id: user.id,
                    role: user.role,
                    email: user.email,
                    name: user.name
                },
                accessToken,
                refreshToken
            }
        });
    });
};
